<!-- Revised on 2024/12/04 by mnavarro -->
<template>
  <tr>
    <th v-for="(item,index) of headers" :key="index" :class="getClasses(index)" @click="headerChanged(index)">
      <a data-sortable href="#" :class="{'dataTable-sorter': item.sort.sorteable}">{{ item.title }}</a>
    </th>
  </tr>
</template>

<script>

  export default {
    name: "GenericTableHeader",
    props: {
      headers: {
        type: Array,
        default: () => [
          {
            title: "",
            column:"",
            sort: {
              sorteable: false,
              order:"desc"
            }
          }
        ]
      },
      listFilters: {
        type: Object,
        default: null,
      },
    },
    emits: ['header-changed'],
    data() {
      return {
        sort: {
          index: -1,
          header: "",
          order: "desc",
        },
        bar: this.headers,
      }
    },
    methods: {
      headerChanged(index) {
        if (!this.headers[index].sort.sorteable) {
          return;
        }
        let oldOrder= this.bar[index].sort.order;
        this.bar[index].sort.order = oldOrder == "desc" ? "asc" : "desc";
        if (this.sort.index!=-1 && index!= this.sort.index){
          this.bar[this.sort.index].sort.order="";
        }
        this.sort = {
          index:index,
          order: this.bar[index].sort.order,
          header:this.bar[index].title,
          column: this.bar[index].column,
        };
        this.$emit('header-changed', this.sort);

      },
      getClasses(index) {
        if(!this.bar[index].sort.sorteable){
          return;
        }
        return this.bar[index].sort.order;
      },
    }
  };

</script>

<style scoped>

  .desc a {
    padding-right: 1.5rem;
  }

  .asc a {
    padding-right: 1.5rem;
  }

</style>